// AUTO-GENERATED — do not edit manually
// Generated by scripts/set-version.js at build time
export const APP_VERSION = "2026.09.24-58c311d";
